import Vue from 'vue'
import store from '../store'
import stickybits from 'stickybits'
import { mapState } from 'vuex'

// methods
import dispatchCurrentKey from './modules/dispatchCurrentKey'

// components
import CircleElement from './components/CircleElement'
import ContentElement from './components/ContentElement'
import CounterElement from './components/CounterElement'

//const el = document.querySelector('.js-homepageGraphic')

const el = document.querySelector('.js-homepageGraphic')


// eslint-disable-next-line no-new
new Vue({

    el,

    components: {
        CircleElement,
        ContentElement,
        CounterElement,
    },

    data: {
        stickyInstance: null,
        observer: null,
    },

    store,

    computed: {
        ...mapState(['currentKey']),
        ...mapState(['inView']),
    },

    created () {
        // window.addEventListener('scroll', this.handleScroll)
    },

    mounted () {
        // this.applyStickyInstance()
        // this.updateStickyCalc()
        this.createIntersectionObserver()
    },

    beforeDestroy () {
        this.observer.disconnect()
    },

    methods: {

        createIntersectionObserver () {

            const options = { threshold: 0.7 }
            this.observer = new IntersectionObserver(([entry]) => {
                if (entry && entry.isIntersecting) {
                    this.$store.dispatch('setInView', true)
                } else {
                    this.$store.dispatch('setInView', false)
                }
            }, options)

            this.observer.observe(this.$el)
        },

        handleScroll (event) {
            this.dispatchCurrentKey()
        },

        dispatchCurrentKey,

        applyStickyInstance () {
            const stickyTray = this.$el.querySelector('.js-stickyTray')
            const verticalOffset = (window.innerHeight - 664) / 2

            this.stickyInstance = stickybits(stickyTray, {
                useFixed: true,
                stickyBitStickyOffset: verticalOffset,
            })
        },

        updateStickyCalc () {
            window.addEventListener('resize', () => {
                const verticalOffset = (window.innerHeight - 664) / 2
                this.stickyInstance.update({ stickyBitStickyOffset: verticalOffset })
            })
        },

        scrollPastGraphic () {
            const { nextElementSibling } = this.$el
            const scrollPoint = pageYOffset + nextElementSibling.getBoundingClientRect().top - 100

            window.scrollTo({
                top: scrollPoint,
                left: 0,
                behavior: 'smooth',
            })
        },
    },
})
